<template>
  <div class="carousel">
    <flickity class="flickity" ref="flickity" :options="flickityOptions">
      <div v-for="(item, index) in dataList" :key="index" class="carousel-cell">
        <img class="carousel-img" :src="item.imgSrc" />
      </div>
    </flickity>
  </div>
</template>

<script>
import Flickity from 'vue-flickity'

export default {
  components: {
    Flickity
  },
  props: {
    images: Array
  },
  data() {
    return {
      flickityOptions: {
        initialIndex: 3,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        freeScroll: true
      },
      dataList: [
        { imgSrc: require('@/assets/images/banner1.png') },
        { imgSrc: require('@/assets/images/banner2.png') },
        { imgSrc: require('@/assets/images/banner3.png') }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./styles.scss";
::v-deep .flickity-viewport{
  height: 400px !important;
  @media (max-width: 1023px) {
    height: 315px !important;
  } 
  @media (max-width: 767px) {
    height: 235px !important;
  }
  @media (max-width: 639px) {
    height: 150px !important;
  }
}
::v-deep .flickity-prev-next-button.next {
    right: 15%;
    @media (max-width: 639px) {
      right: 10% ;
    }
}
::v-deep .flickity-prev-next-button.previous {
    left: 15%;
    @media (max-width: 639px) {
      left: 10% ;
    }
}
::v-deep .flickity-prev-next-button {
    background-color: #eee;
}

</style>